module.exports = __webpack_public_path__ + "img/inter-4.dc1d1103.jpg";